/**
 * @component useFaqAccordion
 * @description FAQ 항목의 펼침/접힘 상태를 제어하는 아코디언 전용 훅입니다.
 * @usage FaqPage에서 질문 클릭 시 열림 상태를 전환하는 데 사용됩니다.
 */

import { useState } from 'react';
import { faqItems } from '../constants/supportData';

export function useFaqAccordion() {
  const [expandedFaq, setExpandedFaq] = useState(faqItems[0]?.question ?? '');

  const toggleFaq = (question) => {
    // [상태 변경]: 동일 항목 클릭 시 닫고, 다른 항목 클릭 시 해당 항목을 엽니다.
    setExpandedFaq((current) => (current === question ? '' : question));
  };

  return { expandedFaq, toggleFaq };
}
